export const updateUserData = (userData) => {
	return {
		userData,
		type: 'UPDATE_USER_DATA'
	}
};